import { API_BASE_URL } from './checkout';

export const subscribeToNewsletter = async ({ email, name, firstName }) => {
  const subscriberName = (name || firstName || '').trim();

  const response = await fetch(`${API_BASE_URL}/newsletter/subscribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, name: subscriberName }),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'No se pudo registrar el email en newsletter.');
  }

  return response.json();
};
